import React from 'react';
import { FormControl, TextField } from '@mui/material';
import WorkflowSessionModalButton from './WorkflowSessionModalButton';
import SmartPasswordField from '../../../../../commonComponents/SmartPasswordField';
import { encryptString } from '../../../../../utils/utilFunctions';

const BasicAuthFields = ({
    t,
    username,
    password,
    disableControl,
    screen,
    fontWeights,
    onInputChange,
    setUsername,
    setPassword,
    setWorkflowSessionModal,
    setValueLabel,
    shouldEncryptDecryptPassword = true,
}) => {
    return (
        <>
            <div style={{ display: "flex", gap: "4px" }}>
                <FormControl className="width-100" size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_USERNAME")}
                        type="text"
                        value={username || ''}
                        disabled={disableControl || false}
                        inputProps={{
                            style: { fontWeight: fontWeights.username }
                        }}
                        onChange={(e) => {
                            onInputChange('USERNAME', e.target.value);
                            setUsername(e.target.value);
                        }}
                        className={"width-100"}
                        name={"USER_NAME"}
                        autoComplete="off"
                    />
                </FormControl>
                {["GET_DATA", "SEND_DATA"].includes(screen) && (
                    <WorkflowSessionModalButton
                        disableControl={disableControl || false}
                        label={t("LBL_USERNAME")}
                        setWorkflowSessionModal={setWorkflowSessionModal}
                        setValueLabel={setValueLabel}
                    />
                )}
            </div>
            <div style={{ display: "flex", gap: "4px" }}>
                <SmartPasswordField
                    variant="outlined"
                    size="small"
                    label={t("LBL_WS_PASSWORD")}
                    value={password || ''}
                    disabled={disableControl || false}
                    inputProps={{
                        style: { fontWeight: fontWeights.password }
                    }}
                    onChange={(e) => {
                        onInputChange(
                            'PASSWORD',
                            shouldEncryptDecryptPassword
                                ? encryptString(e.target.value, process.env.REACT_APP_SECRET_KEY2)
                                : e.target.value
                        );
                        setPassword(e.target.value);
                    }}
                    className={"width-100"}
                    name={"PASS_WORD"}
                    autoComplete="off"
                />
                {["GET_DATA", "SEND_DATA"].includes(screen) && (
                    <WorkflowSessionModalButton
                        disableControl={disableControl || false}
                        label={t("LBL_WS_PASSWORD")}
                        setWorkflowSessionModal={setWorkflowSessionModal}
                        setValueLabel={setValueLabel}
                    />
                )}
            </div>
        </>
    );
};

export default BasicAuthFields;

